'use client'

import * as snippet from '@segment/snippet'
import { useRequireAuth } from '~/hooks/useRequireAuth'
import Script from 'next/script'
import { H } from 'highlight.run'
// import Router from 'next/router'
import { useEffect, useState } from 'react'
import { env } from '~/env.mjs'
import { metaDataKey } from '~/app/(dashboard)/account/constants'

function renderSnippet() {
  const opts = {
    apiKey: env.NEXT_PUBLIC_ANALYTICS_WRITE_KEY!,
    // note: the page option only covers SSR tracking.
    // Page.js is used to track other events using `window.analytics.page()`
    page: true,
  }

  if (env.NEXT_PUBLIC_VERCEL_ENV !== 'production') {
    return snippet.max(opts)
  }

  return snippet.min(opts)
}

// Router.events.on('routeChangeComplete', (url) => {
//   if ((window as any).analytics) {
//     ;(window as any).analytics.page(url)
//   }
// })

export const VendorScripts = () => {
  const { user, isLoading } = useRequireAuth()
  const [hasMounted, setMounted] = useState(false)
  const [segmentReady, setSegmentReady] = useState(false)
  useEffect(() => {
    setMounted(true)
  }, [])

  const isAuthenticated = !isLoading && !!user
  const userUUID = (user?.[metaDataKey] as any)?.uuid
  const hasIdentity = isAuthenticated && typeof userUUID !== 'undefined' && typeof user?.email === 'string'

  useEffect(() => {
    if (hasIdentity && segmentReady && (window as any).analytics) {
      ;(window as any).analytics?.identify(userUUID, {
        name: user!.given_name,
        email: user!.email,
      })
      H.identify(user!.email as string, {
        id: userUUID,
        name: user!.given_name as string,
      })
    }
  }, [hasIdentity, segmentReady, userUUID, user])

  if (!hasMounted) {
    return null
  }
  return (
    <>
      {hasIdentity && (
        <Script
          id="segment-script"
          dangerouslySetInnerHTML={{ __html: renderSnippet() }}
          onReady={() => setSegmentReady(true)}
        />
      )}
      <Script src="https://assets.calendly.com/assets/external/widget.js" />
      {env.NEXT_PUBLIC_VERCEL_ENV === 'production' && (
        <Script
          id="reddit"
          strategy="afterInteractive"
          dangerouslySetInnerHTML={{
            __html: `!function(w,d){if(!w.rdt){var p=w.rdt=function(){p.sendEvent?p.sendEvent.apply(p,arguments):p.callQueue.push(arguments)};p.callQueue=[];var t=d.createElement("script");t.src="https://www.redditstatic.com/ads/pixel.js",t.async=!0;var s=d.getElementsByTagName("script")[0];s.parentNode.insertBefore(t,s)}}(window,document);rdt('init','t2_e5m22dam');rdt('track', 'PageVisit');`,
          }}
        />
      )}
    </>
  )
}
